import { Formation } from '../../types';

export const formations: Formation[] = [
  {
    id: '4-4-2',
    name: '4-4-2',
    positions: ['GK', 'LB', 'LCB', 'RCB', 'RB', 'LM', 'LCM', 'RCM', 'RM', 'LST', 'RST'],
  },
  {
    id: '4-3-3',
    name: '4-3-3',
    positions: ['GK', 'LB', 'LCB', 'RCB', 'RB', 'CDM', 'LCM', 'RCM', 'LW', 'ST', 'RW'],
  },
  {
    id: '3-5-2',
    name: '3-5-2',
    positions: ['GK', 'LCB', 'CCB', 'RCB', 'LWB', 'LCM', 'CDM', 'RCM', 'RWB', 'LST', 'RST'],
  },
  {
    id: '4-2-3-1',
    name: '4-2-3-1',
    positions: ['GK', 'LB', 'LCB', 'RCB', 'RB', 'LCDM', 'RCDM', 'CAM', 'LW', 'RW', 'ST'],
  },
  {
    id: '3-4-3',
    name: '3-4-3',
    positions: ['GK', 'LCB', 'CCB', 'RCB', 'LM', 'LCM', 'RCM', 'RM', 'LW', 'ST', 'RW'],
  },
  {
    id: '5-3-2',
    name: '5-3-2',
    positions: ['GK', 'LWB', 'LCB', 'CCB', 'RCB', 'RWB', 'LCM', 'CCM', 'RCM', 'LST', 'RST'],
  },
]; 